export default "__VITE_ASSET__COuNNRFP__"